"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaQueries = void 0;
var _styledComponents = require("styled-components");
var _ = _interopRequireDefault(require("../"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var mediaQueries = exports.mediaQueries = {
  mediaMediumPlus: function mediaMediumPlus() {
    return (0, _styledComponents.css)(["@media only screen and (min-width:", "px){", ";}"], _["default"].small + 1, _styledComponents.css.apply(void 0, arguments));
  },
  mediaLargePlus: function mediaLargePlus() {
    return (0, _styledComponents.css)(["@media only screen and (min-width:", "px){", ";}"], _["default"].medium + 1, _styledComponents.css.apply(void 0, arguments));
  },
  mediaXLPlus: function mediaXLPlus() {
    return (0, _styledComponents.css)(["@media only screen and (min-width:", "px){", ";}"], _["default"].large + 1, _styledComponents.css.apply(void 0, arguments));
  }
};